module.exports = __webpack_public_path__ + "img/generic.b55b43b0.svg";